import { useCallback, useEffect, useState } from "react";
import { selectionHistoryApi } from "src/Api/selectionHistory";

export function useScheduleRoomSelectionHistories(userId: number) {
  const [scheduleRoomList, setScheduleRoomList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
  if (!userId || userId === 0 ) return; 
  }, [userId]);

  // GET
  // const fetchScheduleRoomList = useCallback(() => {
  //   if (!userId) return;
  //   setLoading(true);
  //   selectionHistoryApi.getScheduleRoomSelectionHistories(userId)
  //     .then(res => setScheduleRoomList(res.data.data))
  //     .finally(() => setLoading(false));
  // }, [userId]);

  const fetchScheduleRoomList = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const res = await selectionHistoryApi.getScheduleRoomSelectionHistories(userId);
      setScheduleRoomList(res.data.data);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  // useEffect(() => { fetchScheduleRoomList(); }, [fetchScheduleRoomList]);

  useEffect(() => {
    fetchScheduleRoomList().then(() => setLoaded(true));
  }, [fetchScheduleRoomList]);

  // POST（保存&リスト取得）
  const storeScheduleRoomSelection = useCallback(async (body: any) => {
    await selectionHistoryApi.storeScheduleRoomSelectionHistory(body);
    fetchScheduleRoomList(); // 保存後に最新リスト再取得
  }, [fetchScheduleRoomList]);

  return { scheduleRoomList, loading, loaded, storeScheduleRoomSelection, fetchScheduleRoomList };
}
